import { Collection } from 'modules/core/lib/mobx-rest'

import Resource from 'modules/custom_resources/store/models/customResources/Resource'

class Resources extends Collection<Resource> {
  get cacheKey(): string {
    return 'resources'
  }

  get indexes() {
    return ['schema_id', 'attachable_type', 'attachable_id']
  }

  model() {
    return Resource
  }
}

const singleton: Resources = new Resources()

export default singleton
